/**
 * Generated from ch6_p05.fla
 */
export function ch6_p05(this: Ich6_p05) {
	const gift = this.gift;
	if (!gift[0] && gift.elementFactory) {
		gift[0] = gift.elementFactory(0,undefined);
	}
	if (gift[0]) {
		ch6_p05_hh_ch6_72dpi_p0506psdAsset1.call(gift[0] as Ich6_p05_hh_ch6_72dpi_p0506psdAsset1);
		gift[0].x = 816.5;
		gift[0].y = 408;
		gift[0].width = 438.00;
		gift[0].height = 398.00;
		gift[0].alpha = 1;
		if (gift[0].onLayout) gift[0].onLayout();
	}
	if (!gift[1] && gift.elementFactory) {
		gift[1] = gift.elementFactory(1,undefined);
	}
	if (gift[1]) {
		ch6_p05_hh_ch6_72dpi_p0506psdAsset2.call(gift[1] as Ich6_p05_hh_ch6_72dpi_p0506psdAsset2);
		gift[1].x = 805;
		gift[1].y = 407;
		gift[1].width = 458.00;
		gift[1].height = 392.00;
		gift[1].alpha = 1;
		if (gift[1].onLayout) gift[1].onLayout();
	}
	if (!gift[2] && gift.elementFactory) {
		gift[2] = gift.elementFactory(2,undefined);
	}
	if (gift[2]) {
		ch6_p05_hh_ch6_72dpi_p0506psdAsset3.call(gift[2] as Ich6_p05_hh_ch6_72dpi_p0506psdAsset3);
		gift[2].x = 874;
		gift[2].y = 495.75;
		gift[2].width = 846.00;
		gift[2].height = 544.50;
		gift[2].alpha = 1;
		if (gift[2].onLayout) gift[2].onLayout();
	}
	if (!gift[3] && gift.elementFactory) {
		gift[3] = gift.elementFactory(3,undefined);
	}
	if (gift[3]) {
		ch6_p05_hh_ch6_72dpi_p0506psdAsset4.call(gift[3] as Ich6_p05_hh_ch6_72dpi_p0506psdAsset4);
		gift[3].x = 824.25;
		gift[3].y = 495.75;
		gift[3].width = 652.50;
		gift[3].height = 544.50;
		gift[3].alpha = 1;
		if (gift[3].onLayout) gift[3].onLayout();
	}
	const bow = this.bow;
	if (!bow[0] && bow.elementFactory) {
		bow[0] = bow.elementFactory(0,undefined);
	}
	if (bow[0]) {
		ch6_p05_hh_ch6_72dpi_p0506psdAsset1tailsdefault.call(bow[0] as Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailsdefault);
		bow[0].x = 824.25;
		bow[0].y = 290;
		bow[0].width = 362.50;
		bow[0].height = 158.00;
		bow[0].alpha = 1;
		if (bow[0].onLayout) bow[0].onLayout();
	}
	if (!bow[1] && bow.elementFactory) {
		bow[1] = bow.elementFactory(1,undefined);
	}
	if (bow[1]) {
		ch6_p05_hh_ch6_72dpi_p0506psdAsset1tails1_2Pulled.call(bow[1] as Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tails1_2Pulled);
		bow[1].x = 829;
		bow[1].y = 294.5;
		bow[1].width = 353.00;
		bow[1].height = 141.00;
		bow[1].alpha = 1;
		if (bow[1].onLayout) bow[1].onLayout();
	}
	if (!bow[2] && bow.elementFactory) {
		bow[2] = bow.elementFactory(2,undefined);
	}
	if (bow[2]) {
		ch6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulled.call(bow[2] as Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulled);
		bow[2].x = 829;
		bow[2].y = 294.5;
		bow[2].width = 353.00;
		bow[2].height = 141.00;
		bow[2].alpha = 1;
		if (bow[2].onLayout) bow[2].onLayout();
	}
	const bg = this.bg;
	ch6_p05_hh_ch6_72dpi_p0506psdAssetbg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const frameRight = this.frameRight;
	ch6_p05_hh_ch6_72dpi_p0506psdAssetframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 357.50;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch6_p05_hh_ch6_72dpi_p0506psdAssetframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 339.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const ribbonLeft = this.ribbonLeft;
	ch6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyLtail1.call(this.ribbonLeft);
	ribbonLeft.x = 737.85;
	ribbonLeft.y = 294.05;
	ribbonLeft.width = 362.50;
	ribbonLeft.height = 244.00;
	ribbonLeft.alpha = 1.00;
	if (ribbonLeft.onLayout) ribbonLeft.onLayout();
	const ribbonLeftEndPos = this.ribbonLeftEndPos;
	ch6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyLtail1.call(this.ribbonLeftEndPos);
	ribbonLeftEndPos.x = 501.8;
	ribbonLeftEndPos.y = 166;
	ribbonLeftEndPos.width = 362.50;
	ribbonLeftEndPos.height = 244.00;
	ribbonLeftEndPos.alpha = 1.00;
	if (ribbonLeftEndPos.onLayout) ribbonLeftEndPos.onLayout();
	const ribbonRight = this.ribbonRight;
	ch6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyRtail1.call(this.ribbonRight);
	ribbonRight.x = 914.15;
	ribbonRight.y = 381.3;
	ribbonRight.width = 380.50;
	ribbonRight.height = 203.50;
	ribbonRight.alpha = 1.00;
	if (ribbonRight.onLayout) ribbonRight.onLayout();
	const ribbonRightEndPos = this.ribbonRightEndPos;
	ch6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyRtail1.call(this.ribbonRightEndPos);
	ribbonRightEndPos.x = 1108.2;
	ribbonRightEndPos.y = 476.3;
	ribbonRightEndPos.width = 380.50;
	ribbonRightEndPos.height = 203.50;
	ribbonRightEndPos.alpha = 1.00;
	if (ribbonRightEndPos.onLayout) ribbonRightEndPos.onLayout();
	const ribbonRightMask = this.ribbonRightMask;
	ribbonRightMask.push(706.17,452.13,1182.30,640.15,1350.33,330.08,962.25,200.05);
	const ribbonLeftMask = this.ribbonLeftMask;
	ribbonLeftMask.push(674.17,434.10,290.07,166.05,492.13,30.00,910.22,210.05);
	return this;
}
function ch6_p05_hh_ch6_72dpi_p0506psdAssetbg(this: Ich6_p05_hh_ch6_72dpi_p0506psdAssetbg) {
	if (this.setLayoutTexture) this.setLayoutTexture("bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p05_hh_ch6_72dpi_p0506psdAsset1(this: Ich6_p05_hh_ch6_72dpi_p0506psdAsset1) {
	if (this.setLayoutTexture) this.setLayoutTexture("1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p05_hh_ch6_72dpi_p0506psdAsset2(this: Ich6_p05_hh_ch6_72dpi_p0506psdAsset2) {
	if (this.setLayoutTexture) this.setLayoutTexture("2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p05_hh_ch6_72dpi_p0506psdAsset3(this: Ich6_p05_hh_ch6_72dpi_p0506psdAsset3) {
	if (this.setLayoutTexture) this.setLayoutTexture("3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p05_hh_ch6_72dpi_p0506psdAsset4(this: Ich6_p05_hh_ch6_72dpi_p0506psdAsset4) {
	if (this.setLayoutTexture) this.setLayoutTexture("4", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p05_hh_ch6_72dpi_p0506psdAssetframeRframe(this: Ich6_p05_hh_ch6_72dpi_p0506psdAssetframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p05_hh_ch6_72dpi_p0506psdAssetframeLframe(this: Ich6_p05_hh_ch6_72dpi_p0506psdAssetframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyLtail1(this: Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyLtail1) {
	if (this.setLayoutTexture) this.setLayoutTexture("Ltail1", 0.215, 0.279);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyRtail1(this: Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyRtail1) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rtail1", 0.806, 0.715);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p05_ribbonRightMask(this: Ich6_p05_ribbonRightMask) {
	return this;
}
function ch6_p05_ribbonLeftMask(this: Ich6_p05_ribbonLeftMask) {
	return this;
}
function ch6_p05_hh_ch6_72dpi_p0506psdAsset1tailsdefault(this: Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailsdefault) {
	if (this.setLayoutTexture) this.setLayoutTexture("tailsdefault", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p05_hh_ch6_72dpi_p0506psdAsset1tails1_2Pulled(this: Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tails1_2Pulled) {
	if (this.setLayoutTexture) this.setLayoutTexture("tails1_2Pulled", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulled(this: Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulled) {
	if (this.setLayoutTexture) this.setLayoutTexture("tailspulled", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich6_p05Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich6_p05Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich6_p05Sprite extends Ich6_p05Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich6_p05Text extends Ich6_p05Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich6_p05Polygon extends Array<number> {
}
interface Ich6_p05 {
	readonly gift: Ich6_p05Array<Ich6_p05_hh_ch6_72dpi_p0506psdAsset1|Ich6_p05_hh_ch6_72dpi_p0506psdAsset2|Ich6_p05_hh_ch6_72dpi_p0506psdAsset3|Ich6_p05_hh_ch6_72dpi_p0506psdAsset4>;
	readonly bow: Ich6_p05Array<Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailsdefault|Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tails1_2Pulled|Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulled>;
	readonly bg: Ich6_p05_hh_ch6_72dpi_p0506psdAssetbg;
	readonly frameRight: Ich6_p05_hh_ch6_72dpi_p0506psdAssetframeRframe;
	readonly frameLeft: Ich6_p05_hh_ch6_72dpi_p0506psdAssetframeLframe;
	readonly ribbonLeft: Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyLtail1;
	readonly ribbonLeftEndPos: Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyLtail1;
	readonly ribbonRight: Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyRtail1;
	readonly ribbonRightEndPos: Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyRtail1;
	readonly ribbonRightMask: Ich6_p05_ribbonRightMask;
	readonly ribbonLeftMask: Ich6_p05_ribbonLeftMask;
}
interface Ich6_p05_hh_ch6_72dpi_p0506psdAssetbg extends Ich6_p05Sprite {
}
interface Ich6_p05_hh_ch6_72dpi_p0506psdAsset1 extends Ich6_p05Sprite {
}
interface Ich6_p05_hh_ch6_72dpi_p0506psdAsset2 extends Ich6_p05Sprite {
}
interface Ich6_p05_hh_ch6_72dpi_p0506psdAsset3 extends Ich6_p05Sprite {
}
interface Ich6_p05_hh_ch6_72dpi_p0506psdAsset4 extends Ich6_p05Sprite {
}
interface Ich6_p05_hh_ch6_72dpi_p0506psdAssetframeRframe extends Ich6_p05Sprite {
}
interface Ich6_p05_hh_ch6_72dpi_p0506psdAssetframeLframe extends Ich6_p05Sprite {
}
interface Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyLtail1 extends Ich6_p05Sprite {
}
interface Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulledcopyRtail1 extends Ich6_p05Sprite {
}
interface Ich6_p05_ribbonRightMask extends Ich6_p05Polygon {
}
interface Ich6_p05_ribbonLeftMask extends Ich6_p05Polygon {
}
interface Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailsdefault extends Ich6_p05Sprite {
}
interface Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tails1_2Pulled extends Ich6_p05Sprite {
}
interface Ich6_p05_hh_ch6_72dpi_p0506psdAsset1tailspulled extends Ich6_p05Sprite {
}
